import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const PatientJourneyStagesChips = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    return applicationFiltersStore.patientJourneyStages.map(
        (patientJourney) => (
            <AppliedFilterChip
                key={patientJourney}
                disabled={props.disabled}
                isApplicable={props.isApplicable}
                onRemove={() =>
                    applicationFiltersStore.setPatientJourneyStages(
                        (applicationFiltersStore.patientJourneyStages ?? [])
                            .map((i) => ({
                                label: applicationFiltersStore.journeyStageOptions.find(
                                    (stage) => stage.value === i,
                                )?.label as string,
                                value: i,
                            }))
                            .filter((stage) => stage.value !== patientJourney),
                    )
                }
            >
                Patient Journey: {
                    applicationFiltersStore.journeyStageOptions.find(
                        (stage) => stage.value === patientJourney,
                    )?.label as string
                }
            </AppliedFilterChip>
        ),
    );
});
